import React, { useState, useEffect, useCallback, useRef } from 'react';

import Box from '@mui/material/Box';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import { UPDATE_STATE } from "../../actions/types";

import IndexedDBManager from "../../indexed-db/indexed-db";
import moment from 'moment';
import {
    Grid, Button, Badge, Modal, IconButton,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@mui/material';
import {
    CloseSharp as CloseSharpIcon,
    ArrowBackIosNewSharp as ArrowBackIosNewSharpIcon,
    ArrowForwardIosSharp as ArrowForwardIosSharpIcon,
    CheckSharp as CheckSharpIcon,
    FlashAuto
}
    from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { getPropertyInfo, updateAppState, getData } from '../../actions/appstate';
import { getPricingDataFormatted, getRTDataFormatted } from '../DynamicTable/tilesData/pricing';
import { API_REGISTRY, APP_CACHE, api_status } from "../../app/config";
import DataService from "../../services/data.service";
import {
    deepCopy, generateRoomTypeExcel, downloadReportToExcel, safeReference, clearAPIRegistryData,
    clearAPIRegistryDataByKey
} from "../../app/util";
import { getForecastNonSegmentedDataNew } from '../DynamicTable/tilesData/forecast';

import "./style.css";

function getPriorDiff(pricingDataRoomType, stayDate, baseRoomCode, roomCode) {
    let prior_diff = 0;
    let prior_data = pricingDataRoomType.find(pdrtItem => pdrtItem.stay_date === stayDate);
    prior_diff = prior_data[roomCode].SellRate - prior_data[baseRoomCode].SellRate;
    return prior_diff;
}

export default function SendPricingRate() {
    const analyze = window.analyze;

    const { auth } = useSelector((state) => state);
    const { user, profile } = auth;
    const dispatch = useDispatch();
    const { app_state, ui_state } = useSelector((state) => state.app.current_state);
    const { roomtype_pricing_overrides, pricing_override_rates, property_id, property_name, room_settings } = app_state;
    const { isRoomTypePricing } = app_state.workspace_controls;
    const [rows, setRows] = useState([]);
    const [numUpdates, setNumUpdates] = useState(0);
    const [roomTypePricingData, setRoomTypePricingData] = useState([]);
    const [openRateClosepopup, setOpenRateClosePopup] = useState(false);
    const [ratePushSucessOpen, setRatePushSuccessOpen] = useState(false);
    const [ratePushSuccess, setRatePushSuccess] = useState(false);
    const [ratePushFail, setRatePushFail] = useState(false);
    const [modalOpen, setModalOpen] = useState(true);
    const [confirmAllBtnEnabled, setConfirmAllBtnEnabled] = useState(true);
    const [confirmAllBtnSpinner, setConfirmAllBtnSpinner] = useState(false);
    const [compState, setCompState] = useState({
        count: 0,
        rows: [],
        pushSuccess: false,
        pushError: false,
        progress: {
            all: 'idle',
        },
        pushStatus: {},
        pushedCount: 0,
        successTimeout: 4000,

    });
    const ratePushRef = useRef({ inProgress: false });
    let baseRoom = room_settings.find(r => r.is_base)

    useEffect(() => {
        let isSubscribed = true;
        console.log("effect 1", ui_state.pricingRateModalOpen)
        if (ui_state.pricingRateModalOpen === true) {

            const pricingData = getPricingDataFormatted(app_state, isRoomTypePricing);
            if (isRoomTypePricing === true && roomtype_pricing_overrides) {
                const roomPricingDataArr = []
                Object.keys(roomtype_pricing_overrides).forEach(stay_date => {
                    const dateUpdates = []
                    room_settings.forEach((room) => {
                        let previous_rate = 0;
                        // pricingData.map(pricing => {
                        //     if (pricing.stay_date === stay_date && pricing[room.room_code]) {
                        //         previous_rate = pricing[room.room_code].SellRate; // dont know about this
                        //     }
                        // })
                        if (roomtype_pricing_overrides[stay_date] &&
                            roomtype_pricing_overrides[stay_date][room.room_code]) {
                            let roomCodeUpdate = { ...roomtype_pricing_overrides[stay_date][room.room_code] };
                            previous_rate = (roomCodeUpdate.previous_data && roomCodeUpdate.previous_data.SellRate) ? roomCodeUpdate.previous_data.SellRate : 0;

                            roomCodeUpdate["previous_rate"] = previous_rate;
                            roomCodeUpdate["room_code"] = room.room_code;
                            if ((previous_rate !== roomCodeUpdate.SellRate && roomCodeUpdate.SellRate !== undefined)) {
                                dateUpdates.push(roomCodeUpdate);
                            }
                        }


                    })
                    if (dateUpdates.length > 0) {
                        let priceData = {
                            ...roomtype_pricing_overrides[stay_date],
                            stay_date,
                            date_updates: dateUpdates
                        };

                        roomPricingDataArr.push(priceData)
                    }


                })
                setRoomTypePricingData(roomPricingDataArr);
                setNumUpdates(roomPricingDataArr.length)
                if (roomPricingDataArr.length > 0) {
                    setConfirmAllBtnEnabled(true); // Button Enabled
                }
            }
        } else {

            rows.forEach((row) => {
                if (row.success_push) {
                    delete app_state.pricing_override_rates[row.stay_date];
                    if (app_state.override_rates_input) {
                        delete app_state.override_rates_input[row.stay_date];
                    }
                }
            })
        }
        return () => (isSubscribed = false);
    }, [app_state.pricing_override_rates,
    app_state.roomtype_pricing_overrides,
    ui_state.pricingRateModalOpen])
    useEffect(() => {
        console.log("effect 2", ui_state.pricingRateModalOpen)
        setConfirmAllBtnEnabled(true); // Button Enabled
        setConfirmAllBtnSpinner(false); // Spinner Disabled
        if (isRoomTypePricing === false && pricing_override_rates) {
            const pricingData = getPricingDataFormatted(app_state, isRoomTypePricing);
            const dataArr = [];
            Object.keys(pricing_override_rates).map(date => {
                const { override_rate, approved, recommend_accept, previous_data = {}, all_rooms_data } = pricing_override_rates[date];
                let current_rate = (all_rooms_data && all_rooms_data[baseRoom.room_code]) ? all_rooms_data[baseRoom.room_code].SellRate : 0;

                // pricingData.map(pricing => {
                //     if (pricing.stay_date === date) {
                //         current_rate = pricing.SellRate; // dont know about this

                //     }
                // })
                if (approved === true) {
                    const row = {
                        stay_date: date,
                        current_rate,
                        override_rate,
                    }
                    row.message = pricing_override_rates[date].message;
                    row.success_push = pricing_override_rates[date].success_push;
                    row.loading = pricing_override_rates[date].loading;
                    row.fail = pricing_override_rates[date].fail;
                    dataArr.push(row)
                }
            })
            setCompState(prevState => {
                prevState.count = dataArr.length;
                prevState.rows = [...dataArr];
                return prevState;
            })
            setRows(dataArr);
            setNumUpdates(dataArr.length);
        }

    }, [ui_state.pricingRateModalOpen]);
    useEffect(() => {
        console.log("ui_state.showspinner", ui_state.showspinner);
        let count_all_push = 0;
        let count_success_push = 0;

        if (isRoomTypePricing === false) {
            count_all_push = rows.length;
            count_success_push = rows.filter(row => row.success_push === true).length;
        }
        else {
            count_all_push = roomTypePricingData.length;
            count_success_push = roomTypePricingData.filter(row => row.success_push === true).length;
        }

        if (count_all_push !== count_success_push) {
            setConfirmAllBtnEnabled(true); // Button Enabled
            setConfirmAllBtnSpinner(false); // Spinner Disabled
        }
        else {
            setConfirmAllBtnEnabled(false); // Button Disabled
            setConfirmAllBtnSpinner(false); // Spinner Disabled
        }
    }, [ui_state.showspinner]);

    useEffect(() => {
        if (ratePushSucessOpen && !ui_state.showspinner && !app_state.data_load) {
            closeModalDelayed();
        }
    }, [ratePushSucessOpen, ui_state.showspinner, app_state.data_load])

    const handleDelete = (index) => {
        const { stay_date } = rows[index];
        rows.splice(index, 1);
        delete pricing_override_rates[stay_date]
        if (app_state.override_rates_input) {
            delete app_state.override_rates_input[stay_date]
        }
        if (rows.length === 0) {
            setConfirmAllBtnEnabled(false); // Button Disabled
            closeModalDelayed(0);
        }
        setRows(rows);
        dispatch(updateAppState("change_pricing_rates", {
            app_state: {
                pricing_override_rates: { ...pricing_override_rates }
            }
        }))
    }
    const closeModalDelayed = (timeout = 4000) => {
        setTimeout(() => {
            setRatePushSuccessOpen(false);

            APP_CACHE.pricingRateModalOpen = false;
            // dispatch({ type: UPDATE_STATE, payload: { ui_state: { pricingRateModalOpen: false } } });
            if (app_state.bulkPricingSave) {
                app_state.primary_stay_range = { ...app_state.historicalRange };
            }
            dispatch({
                type: UPDATE_STATE,
                payload: {
                    app_state: {
                        bulkPricingSave: false,
                        pricing_override_rates: {},
                        roomtype_pricing_overrides: {},
                        primary_stay_range: app_state.primary_stay_range
                    },
                    ui_state: { pricingRateModalOpen: false }
                }
            });

        }, timeout);
    }

    const clearCache = () => {
        const idbManager = new IndexedDBManager();

        idbManager.openDB()
            .then(() => {
                idbManager.cleanIdbStore();
                //  DataService.updateDataCache("OSR", { data: null, loaded: false, loading: false, reqParams: null });
                // DataService.updateDataCache("OSRSegment", { data: null, loaded: false, loading: false, reqParams: null });
                // DataService.updateDataCache("OSRYear", { data: null, loaded: false, loading: false, reqParams: null });
                // api_status["OSR"]="";
                let series = DataService.getSeriesById("OSR");
                series.data = null;
                // series = DataService.getSeriesById("OSRSegment");
                // series.data = null;
                console.log("clear cache");
            })
            .then(() => {
                idbManager.closeDB();
            });
    }
    const handleRatePush = useCallback((dayData) => {
        console.log("push");
        setConfirmAllBtnEnabled(false); // Button Disabled
        setConfirmAllBtnSpinner(true); // Spinner Enabled
        let { uri } = API_REGISTRY["SendRatePush"];
        uri += app_state.property_id + "/";
        let request = {};
        const pricingData = getPricingDataFormatted(app_state);
        const pricingDataRoomType = getPricingDataFormatted(app_state, true);
        const forecastData = getForecastNonSegmentedDataNew();
        // const otbData = deepCopy(DataService.getSeriesById("OSR").data.data);

        // LRV-1066 If OTB data not present then assign empty array
        const otbData = DataService.getSeriesById("OSR").data ? deepCopy(DataService.getSeriesById("OSR").data.data) : [];

        const otbRoomTypeData = getRTDataFormatted(pricingDataRoomType, app_state.room_settings); // LRV-1124
        let rates = {}, otb = {}, forecast = {}, otbRoomType = {};
        let baseRoom = room_settings.find(r => r.is_base)
        if (dayData) {
            if (isRoomTypePricing === false) {

                request = {
                    ...API_REGISTRY["SendRatePush"].payload,
                    "user_id": user.user_id,
                    "pid": app_state.property_id,
                    "as_of_date": app_state.as_of_date,
                }
                request["segment_type"] = "market_code";
                request["rate_code"] = "TBAR";
                if (app_state.pricing_override_rates[dayData.stay_date].previous_data) {
                    rates = app_state.pricing_override_rates[dayData.stay_date].previous_data;
                }
                // pricingData.map(pricing => {
                //     if (pricing.stay_date === dayData.stay_date) {
                //         rates = pricing;
                //     }
                // })
                forecastData.map(fdata => {
                    if (fdata.index.date === dayData.stay_date) {
                        forecast = fdata.HotelTotal.primary;
                    }
                })
                otbData.map(onthebooks => {
                    if (onthebooks.index.date === dayData.stay_date) {
                        otb = onthebooks.HotelTotal.primary;
                    }
                })
                otbRoomTypeData.map(roomType => {
                    if (roomType.index.date === dayData.stay_date) {
                        otbRoomType = roomType.HotelTotal.primary;
                    }
                })
                if (!rates.RecSellRate) {
                    rates.RecSellRate = 0;
                }
                if (!rates.SellRate) {
                    rates.SellRate = 0;
                }
                let user_action = (dayData.override_rate === rates.RecSellRate) ? "recommendation_accept" : "overridden";
                request.rate_updates = [];
                request.rate_updates.push({
                    "stay_date": dayData.stay_date,
                    "new_rate": Number(dayData.override_rate),
                    "old_rate": Number(rates.SellRate),
                    "system_recommended_rate": Number(rates.RecSellRate),
                    "user_action": user_action,
                    "snapshot": {
                        "otb": { rooms: otb.Rooms, occ: otb.Occ, adr: otb.ADR, revenue: otb.Revenue },
                        "forecast": { rooms: forecast.Rooms, occ: forecast.Occ, adr: forecast.ADR, revenue: forecast.Revenue },
                        "rates": { "current_rate": rates.SellRate, "recommended_rate": rates.RecSellRate }
                    },
                })
                if (app_state.override_rates_input) {
                    delete app_state.override_rates_input[dayData.stay_date];
                }
                setRows(prevRows => {
                    return [...prevRows.map(row => {
                        if (row.stay_date === dayData.stay_date) {
                            row.loading = true;
                        }
                        return row;
                    })]
                });
            } else {

                request = {
                    ...API_REGISTRY["SendRatePushRoomType"].payload,
                    "user_id": user.user_id,
                    "pid": app_state.property_id,
                    "as_of_date": app_state.as_of_date,

                }
                let propertyInfo = getPropertyInfo(profile.property_details, property_id);
                let room_settings = safeReference(propertyInfo.system_settings[0], [], ["inventory_settings", "current", "room_settings"])
                app_state.roomtype_pricing_overrides[dayData.stay_date].loading = true;
                let room_rates = [];
                otbRoomType = otbRoomTypeData.find(item => moment(item.index.date).format("YYYY-MM-DD") === dayData.stay_date);

                dayData.date_updates.forEach(room_data => {
                    let roomDetails;
                    room_settings.map(room => {
                        if (room.room_code === room_data.room_code) {
                            roomDetails = room;
                        }
                    })

                    let user_action = "recommendation_accept";
                    if (baseRoom.room_code === room_data.room_code) {
                        if (room_data.SellRate !== room_data.previous_data.RecSellRate) {
                            user_action = "overridden";
                        }
                    } else {
                        let diff = room_data.current_differential;
                        if (diff === undefined) {
                            let previous_rate = room_data.previous_data.SellRate;
                            let previous_base_rate = room_data.previous_data.baseRoom.SellRate;
                            diff = previous_rate - previous_base_rate;
                        }
                        if (diff !== room_data.previous_data.lodgiq_differential) {
                            user_action = "overridden";
                        }
                    }

                    let prior_diff = room_data.previous_data.SellRate - room_data.previous_data.baseRoom.SellRate;
                    let rooms_sold = otbRoomType["Segment_" + room_data.room_code]?.primary?.Rooms || 0;
                    room_rates.push({
                        "room_type": room_data.room_code,
                        "new_rate": Number(room_data.SellRate),
                        "diff_on_record": 0,
                        "old_rate": Number(room_data.previous_rate),
                        "prior_diff": prior_diff,
                        "is_base": roomDetails.is_base,
                        "user_action": user_action,
                        "snapshot": {
                            "pms_room_code": room_data.room_code,
                            "otb": {
                                "rooms_sold": rooms_sold,
                                "room_capacity": roomDetails.inventory,
                            }
                        },
                        "is_override": true,
                        "is_rec_accept": false,
                        "override_type": "rate",
                        "rec_accept_type": "",
                        "is_cascade": false
                    })
                })
                request.rate_updates = [];
                //let lowestRate = findLowestRoomTypeRate(room_rates,pricingDataRoomType.find(pdrtItem => pdrtItem.stay_date === dayData.stay_date));
                let lowestRate = findLowestRoomTypeRate(room_rates, dayData);

                request.rate_updates.push({
                    "stay_date": dayData.stay_date,
                    "snapshot": {
                        "otb": {},
                        "forecast": {},
                        "rates": { "current_rate": lowestRate.old_rate, "recommended_rate": lowestRate.RecSellRate }
                    },
                    room_rates
                })
                setRoomTypePricingData(pervData => {
                    return [...pervData.map(data => {
                        if (data.stay_date === dayData.stay_date) {
                            data.loading = true;

                        }
                        return data;
                    })]
                });
            }


            // dispatch(updateAppState("confirmed_rates_success", {
            //     app_state: {
            //         pricing_override_rates: { ...app_state.pricing_override_rates },
            //         roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
            //     },
            // }))
            dispatch({
                type: UPDATE_STATE,
                payload: {
                    app_state: {
                        pricing_override_rates: { ...app_state.pricing_override_rates },
                        roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                    }
                }
            });
        } else {

            if (isRoomTypePricing === false) {
                request = {
                    ...API_REGISTRY["SendRatePush"].payload,
                    "user_id": user.user_id,
                    "pid": app_state.property_id,
                    "as_of_date": app_state.as_of_date,
                }
                request["segment_type"] = "market_code";
                request["rate_code"] = "TBAR";
                request.rate_updates = [];
                rows.map(data => {
                    // Skip the Row if already pushed
                    if (!data.success_push) {
                        if (app_state.pricing_override_rates[data.stay_date].previous_data) {
                            rates = app_state.pricing_override_rates[data.stay_date].previous_data;
                        }
                        // pricingData.map(pricing => {
                        //     if (pricing.stay_date === data.stay_date) {
                        //         rates = pricing;
                        //     }
                        // })

                        forecastData.map(fdata => {
                            if (fdata.index.date === data.stay_date) {
                                forecast = fdata.HotelTotal.primary;
                            }
                        })
                        otbData.map(onthebooks => {
                            if (onthebooks.index.date === data.stay_date) {
                                otb = onthebooks.HotelTotal.primary;
                            }
                        })
                        if (!rates.RecSellRate) {
                            rates.RecSellRate = 0;
                        }
                        if (!rates.SellRate) {
                            rates.SellRate = 0;
                        }
                        let user_action = (data.override_rate === rates.RecSellRate) ? "recommendation_accept" : "overridden";

                        request.rate_updates.push({
                            "stay_date": data.stay_date,
                            "new_rate": Number(data.override_rate),
                            "old_rate": Number(rates.SellRate),
                            "system_recommended_rate": rates.RecSellRate,
                            "user_action": user_action,
                            "snapshot": {
                                "otb": { rooms: otb.Rooms, occ: otb.Occ, adr: otb.ADR, revenue: otb.Revenue },
                                "forecast": { rooms: forecast.Rooms, occ: forecast.Occ, adr: forecast.ADR, revenue: forecast.Revenue },
                                "rates": { "current_rate": rates.SellRate, "recommended_rate": rates.RecSellRate }

                            },
                        })
                        if (app_state.override_rates_input) {
                            delete app_state.override_rates_input;
                        }
                    }
                })

            } else {

                request = {
                    ...API_REGISTRY["SendRatePushRoomType"].payload,
                    "user_id": user.user_id,
                    "pid": app_state.property_id,
                    "as_of_date": app_state.as_of_date,

                }
                let propertyInfo = getPropertyInfo(profile.property_details, property_id);
                let room_settings = safeReference(propertyInfo.system_settings[0], [], ["inventory_settings", "current", "room_settings"])
                request.rate_updates = [];
                roomTypePricingData.forEach(data => {
                    if (data.success_push === true) {
                        return;
                    }
                    let room_rates = [];
                    let otbRoomType = otbRoomTypeData.find(item => moment(item.index.date).format("YYYY-MM-DD") === data.stay_date);
                    data.date_updates.forEach(room_data => {
                        let roomDetails = {};

                        let user_action = "recommendation_accept";
                        if (baseRoom.room_code === room_data.room_code) {
                            if (room_data.SellRate !== room_data.previous_data.RecSellRate) {
                                user_action = "overridden";
                            }
                        } else {
                            let diff = room_data.current_differential;
                            if (diff === undefined) {
                                let previous_rate = room_data.previous_data.SellRate;
                                let previous_base_rate = room_data.previous_data.baseRoom.SellRate;
                                diff = previous_rate - previous_base_rate;
                            }
                            if (diff !== room_data.previous_data.lodgiq_differential) {
                                user_action = "overridden";
                            }
                        }

                        room_settings.map(room => {
                            if (room.room_code === room_data.room_code) {
                                roomDetails = room;
                            }
                        })
                        if (room_data.SellRate) {
                            //let prior_diff = getPriorDiff(pricingDataRoomType, data.stay_date, baseRoom.room_code, room_data.room_code)
                            let prior_diff = room_data.previous_data.SellRate - room_data.previous_data.baseRoom.SellRate;
                            let rooms_sold = otbRoomType["Segment_" + room_data.room_code]?.primary?.Rooms || 0;
                            room_rates.push({
                                "room_type": room_data.room_code,
                                "new_rate": Number(room_data.SellRate),
                                "diff_on_record": 0,
                                "old_rate": Number(room_data.previous_rate),
                                "prior_diff": prior_diff,
                                "is_base": roomDetails.is_base,
                                "user_action": user_action,
                                "snapshot": {
                                    "pms_room_code": room_data.room_code,
                                    "otb": {
                                        "rooms_sold": rooms_sold,
                                        "room_capacity": roomDetails.inventory,
                                    }
                                },
                                "is_override": true,
                                "is_rec_accept": false,
                                "override_type": "rate",
                                "rec_accept_type": "",
                                "is_cascade": false
                            })
                        }

                    })
                    //let lowestRate = findLowestRoomTypeRate(room_rates,pricingDataRoomType.find(pdrtItem => pdrtItem.stay_date === data.stay_date));
                    let lowestRate = findLowestRoomTypeRate(room_rates, data);

                    request.rate_updates.push({
                        "stay_date": data.stay_date,
                        "snapshot": {
                            "otb": {},
                            "forecast": {},
                            "rates": { "current_rate": lowestRate.old_rate, "recommended_rate": lowestRate.RecSellRate }
                        },
                        room_rates
                    })

                })
            }
        }

        DataService.getData({ api: uri, request }).then((res) => {
            setRatePushSuccess(true);
            if (res.status === "success") {
                clearCache();
            }
            if (!dayData) {
                if (res.status !== "success") {
                    if (isRoomTypePricing === false) {
                        Object.keys(app_state.pricing_override_rates).forEach(stay_date => {
                            app_state.pricing_override_rates[stay_date].fail = true;
                            app_state.pricing_override_rates[stay_date].message = res.message;
                        })

                        setRows(prevRows => {
                            return [...prevRows.map(row => {
                                row.fail = true;
                                row.message = res.message;
                                row.loading = false;
                                return row;
                            })]
                        });
                    }
                    else {

                        Object.keys(app_state.roomtype_pricing_overrides).forEach(stay_date => {
                            app_state.roomtype_pricing_overrides[stay_date].fail = true;
                            app_state.roomtype_pricing_overrides[stay_date].message = res.message;
                        })
                        setRoomTypePricingData(pervData => {
                            return [...pervData.map(data => {

                                data.loading = false;
                                data.fail = true;
                                data.message = res.message

                                return data;
                            })]
                        });
                    }
                    analyze.track("pricing_ratepush_success", {
                        push_success: false,
                        push_type: 'manual_override',
                        pid: app_state.property_id,
                        data_level: isRoomTypePricing ? 'room_type' : 'hotel',
                        stay_dates_count: request?.rate_updates?.length || 1,
                    }, null, { app_state, ui_state });
                    setConfirmAllBtnEnabled(true); // Button Enabled
                    setConfirmAllBtnSpinner(false); // Spinner Disabled
                } else {
                    dispatch({
                        type: UPDATE_STATE,
                        payload: {
                            app_state: {
                                data_load: true,
                                pricing_override_rates: {},
                                roomtype_pricing_overrides: {}
                            },
                            ui_state: {
                                showspinner: true,
                            }
                        }
                    });
                    // clear rows and roomTypePricingData and close modal only after refresh completes
                    setRatePushSuccessOpen(true);
                    setRows([]);
                    setRoomTypePricingData(prev => {
                        prev = [];
                        return prev;
                    });
                    //closeModalDelayed();

                    const allRec = request.rate_updates?.every(u => u.user_action === 'recommendation_accept');
                    analyze.track("pricing_ratepush_success", {
                        room_type_pricing: "No",
                        push_success: true,
                        push_type: allRec ? 'recommendation_accept' : 'manual_override',
                        pid: app_state.property_id,
                        data_level: isRoomTypePricing ? 'room_type' : 'hotel',
                        rate_code: request?.rate_code,
                        stay_dates_count: request?.rate_updates?.length || 1,
                    }, null, { app_state, ui_state });
                }

            } else {

                if (isRoomTypePricing === false) {
                    app_state.pricing_override_rates[dayData.stay_date].loading = false;

                } else {
                    app_state.roomtype_pricing_overrides[dayData.stay_date].loading = false;

                }

                if (res.status !== 'success') {
                    if (isRoomTypePricing === false) {
                        app_state.pricing_override_rates[dayData.stay_date].fail = true;
                        app_state.pricing_override_rates[dayData.stay_date].message = res.message;

                        setRows(prevRows => {
                            return [...prevRows.map(row => {
                                if (row.stay_date === dayData.stay_date) {
                                    row.message = res.message;
                                    row.fail = true;
                                    row.loading = false;
                                }
                                return row;
                            })]
                        });

                    } else {
                        app_state.roomtype_pricing_overrides[dayData.stay_date].fail = true;
                        app_state.roomtype_pricing_overrides[dayData.stay_date].message = res.message;
                        setRoomTypePricingData(pervData => {
                            return [...pervData.filter(data => {
                                if (data.stay_date === dayData.stay_date) {
                                    data.loading = false;
                                    data.fail = true;
                                    data.message = res.message
                                }
                                return data;
                            })]
                        });
                    }
                    analyze.track("pricing_ratepush_success", {
                        push_success: false,
                        push_type: 'manual_override',
                        pid: app_state.property_id,
                        data_level: isRoomTypePricing ? 'room_type' : 'hotel',
                        stay_dates_count: 1,
                    }, null, { app_state, ui_state });
                    setConfirmAllBtnEnabled(true); // Button Enabled
                    setConfirmAllBtnSpinner(false); // Spinner Disabled
                }
                else {
                    if (isRoomTypePricing === false) {
                        app_state.pricing_override_rates[dayData.stay_date].success_push = true;
                    } else {
                        app_state.roomtype_pricing_overrides[dayData.stay_date].success_push = true;
                    }
                    if (ratePushRef.current.inProgress === false) {
                        dispatch({
                            type: UPDATE_STATE,
                            payload: {
                                app_state: {
                                    data_load: true,
                                },
                                ui_state: {
                                    showspinner: true,
                                }
                            }
                        })
                        ratePushRef.current.inProgress = true;
                    }

                    if (isRoomTypePricing === true) {
                        let updatedRoomTypePricing = [];
                        setRoomTypePricingData(pervData => {
                            updatedRoomTypePricing = pervData.filter(data => {
                                if (data.stay_date === dayData.stay_date) {
                                    data.loading = false;
                                    data.success_push = true;

                                }
                                return data;
                            })
                            return [...updatedRoomTypePricing]
                        });
                        let lenleft = updatedRoomTypePricing.filter(i => !i.success_push).length;
                        if (lenleft === 0) {
                            setRatePushSuccessOpen(true);
                            //closeModalDelayed()
                        }

                    } else {
                        let updatedRows = [];
                        setRows(prevRows => {
                            prevRows = deepCopy(prevRows);
                            updatedRows = prevRows.map(row => {
                                if (row.stay_date === dayData.stay_date) {
                                    row.success_push = true;
                                    row.loading = false;
                                }
                                return row;
                            });
                            return [...updatedRows]
                        });
                        let lenLeft = updatedRows.filter(i => !i.success_push).length;
                        if (lenLeft === 0) {
                            setRatePushSuccessOpen(true);
                            //closeModalDelayed()
                        }
                        // if(lenleft === 0){
                        //     setRatePushSuccessOpen(true)
                        // }
                    }

                    //Record Pricing rate push success
                    const singleAction = request.rate_updates?.[0]?.user_action;
                    analyze.track("pricing_ratepush_success", {
                        room_type_pricing: "Yes",
                        push_success: true,
                        push_type: singleAction === 'recommendation_accept' ? 'recommendation_accept' : 'manual_override',
                        pid: app_state.property_id,
                        data_level: isRoomTypePricing ? 'room_type' : 'hotel',
                        stay_dates_count: 1,
                    }, null, { app_state, ui_state });
                }
                // dispatch(updateAppState("update_pricing_override_rates", {
                //     app_state: {
                //         pricing_override_rates: { ...app_state.pricing_override_rates },
                //         roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                //     }
                // }));

                dispatch({
                    type: UPDATE_STATE,
                    payload: {
                        app_state: {
                            pricing_override_rates: { ...app_state.pricing_override_rates },
                            roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                        }
                    }
                });
            }
        }).catch(err => {
            setConfirmAllBtnEnabled(true); // Button Enabled
            setConfirmAllBtnSpinner(false); // Spinner Disabled
            setRatePushSuccess(false)
            if (dayData) {
                setRows(prevRows => {
                    return [...prevRows.map(row => {
                        if (row.stay_date === dayData.stay_date) {
                            row.fail = true;
                            row.loading = false;
                        }
                        return row;
                    })]
                });
            }
        }).finally(() => {
            ratePushRef.current.inProgress = false;
        })
        // setTimeout(()=>{
        //     clearCache();
        // },15000)

    }, [ui_state.pricingRateModalOpen, roomTypePricingData, rows, app_state.pricing_override_rates, app_state.roomtype_pricing_overrides]);

    // const findLowestRoomTypeRate = (stayDateData, rtpRateData)=> {
    //     let lowestRate=stayDateData[0];
    //     lowestRate.RecSellRate = rtpRateData[stayDateData[0].room_type].RecSellRate;
    //     stayDateData.forEach(item=>{
    //         if( lowestRate.old_rate > item.old_rate){
    //             lowestRate =  item;
    //             lowestRate.RecSellRate = rtpRateData[item.room_type].RecSellRate;
    //         }
    //     })
    //     return lowestRate;
    // }
    const findLowestRoomTypeRate = (stayDateData, rtpRateData) => {
        let lowestRate = stayDateData[0];
        lowestRate.RecSellRate = rtpRateData[stayDateData[0].room_type].previous_data.RecSellRate;
        stayDateData.forEach(item => {
            if (lowestRate.old_rate > item.old_rate) {
                lowestRate = item;
                lowestRate.RecSellRate = rtpRateData[item.room_type].previous_data.RecSellRate;
            }
        })
        return lowestRate;
    }
    const ratePushSucessDiv = (<>
        <Grid item className='success-popup'></Grid>
        <div className='rate-push-success'>
            <div className='rate-push-success-container'>
                <Grid item className='task-complete'></Grid>
                <Grid item className='success-text'>Success!</Grid>
                <Grid item>Check the Rates Push Status Below </Grid>
                {!ui_state.showspinner && !app_state.data_load && (<Button variant="contained" onClick={() => {

                    setRatePushSuccessOpen(false);
                    Object.keys(app_state.pricing_override_rates).forEach(stay_date => {
                        if (app_state.pricing_override_rates[stay_date].success_push) {
                            delete app_state.pricing_override_rates[stay_date];
                        }
                    })
                    Object.keys(app_state.roomtype_pricing_overrides).forEach(stay_date => {
                        if (app_state.roomtype_pricing_overrides[stay_date].success_push) {
                            delete app_state.roomtype_pricing_overrides[stay_date];
                        }
                    })
                    let tile = (isRoomTypePricing) ? "rm_room_type_ratesend_status" : "DailyRatesendStatus";
                    if (app_state.bulkPricingSave) {
                        app_state.roomtype_pricing_overrides = {};
                        app_state.primary_stay_range = { ...app_state.historicalRange };
                    }
                    APP_CACHE.pricingRateModalOpen = false;
                    APP_CACHE.active_tiles = [tile];
                    dispatch({
                        type: UPDATE_STATE, payload: {
                            app_state: {
                                bulkPricingSave: false,
                                pricing_override_rates: app_state.pricing_override_rates,
                                primary_stay_range: app_state.primary_stay_range,
                                roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides },
                                workspace_controls: {
                                    ...app_state.workspace_controls,
                                    logsRatePushMode: 'date_range',
                                },
                                data_load: true,
                            },
                            ui_state: { pricingRateModalOpen: false, active_tiles: [tile], showspinner: true }
                        }
                    });

                }} className='button-green'>
                    {isRoomTypePricing === false && "Daily Rate Push Status"}
                    {isRoomTypePricing === true && "Rooms Rate Push Status"}
                </Button>)}
            </div>
        </div></>);
    const rateCloseBulk = (<>
        <Grid item className='success-popup'></Grid>
        <div className='rate-push-success'>
            <div className='rate-push-success-container'>
                <Grid item className='task-complete'></Grid>
                <Grid item className='success-text'>Are you sure you want to close?</Grid>
                <Grid item>Closing the rate push cart will delete your changes </Grid>
                <Button variant="contained" onClick={() => {

                    setOpenRateClosePopup(false);
                    if (app_state.bulkPricingSave) {
                        app_state.roomtype_pricing_overrides = {};
                    }
                    APP_CACHE.pricingRateModalOpen = false;
                    dispatch({
                        type: UPDATE_STATE, payload: {
                            app_state: {
                                bulkPricingSave: false,
                                roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides },
                                primary_stay_range: { ...app_state.historicalRange }
                            },
                            ui_state: { pricingRateModalOpen: false }
                        }
                    });

                }} className='button-green'>
                    Close Rate Push
                </Button>
                <Button variant="contained" onClick={() => {
                    setOpenRateClosePopup(false);
                }} className='button-green' > Cancel</Button>
            </div>
        </div></>);
    const housePricingTable = (<TableContainer className='rate-push-table' sx={{ maxHeight: "91%" }}>
        <Table stickyHeader aria-label="simple table">
            <TableHead>
                <TableRow sx={{ backgroundColor: '#606060', '& td, & th': { pt: 1, pb: 1 } }}>
                    <TableCell align="center">DATE	</TableCell>
                    <TableCell align="center">CURRENT RATE</TableCell>
                    <TableCell align="center">APPROVED RATE</TableCell>
                    <TableCell align="left" className='status-column'>STATUS</TableCell>
                </TableRow>
            </TableHead>
            <TableBody className='ratepush-tbody pricing' sx={{ overflowX: "hidden", overflowY: "auto" }}>


                {rows.length > 0 ?
                    rows.map((row, index) => (
                        <TableRow
                            key={index}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 }, '& td, & th': { pt: 1, pb: 1, fontSize: 14 } }}
                        >
                            <TableCell align='center' component="th" scope="row">
                                {moment(row.stay_date).format("ddd, MMM DD, YYYY")}
                            </TableCell>
                            <TableCell component="th" scope="row" align='center' sx={{ color: "#000" }}>
                                {ui_state.currency_symbol} {row.current_rate}
                            </TableCell>
                            <TableCell component="th" scope="row" align='center' sx={{ fontWeight: "bold" }}>
                                {ui_state.currency_symbol} {row.override_rate}
                            </TableCell>

                            <TableCell component="th" scope="row">
                                <Grid container direction="row" justifyContent="space-between" alignItems="center"
                                >

                                    <Grid item >
                                        {(!row.success_push
                                            && !row.loading && !row.fail) &&
                                            <Button onClick={() => handleRatePush(row)} className='icon-btn icon-status icon-ratepush'>
                                                <span className='upload-button'></span>
                                            </Button>
                                        }
                                        {(!row.fail && !row.loading && row.success_push === true) && (
                                            <Button className="icon-btn icon-status">
                                                <span className='in-progress'></span>
                                            </Button>
                                        )}
                                        {(!row.fail && !row.success_push && row.loading) && <Grid item xs={4}>

                                            <CircularProgress size={20} />

                                        </Grid>}
                                        {(!row.loading && !row.success_push && row.fail === true) &&
                                            (<Tooltip title={(row.message) ? row.message : ""} placement="bottom-start" arrow>
                                                <Button className='icon-btn icon-status icon-warning'>
                                                    <span className='error' ></span>
                                                </Button>
                                            </Tooltip>)}
                                    </Grid>
                                    <Grid item>
                                        <Button onClick={() => {
                                            handleDelete(index, row.id)
                                        }} className='icon-btn icon-status icon-cancel'>
                                            <span className='push-delete'></span>
                                        </Button>
                                    </Grid>
                                </Grid>

                            </TableCell>
                        </TableRow>
                    ))
                    : (
                        <p style={{ paddingLeft: '16px' }}>
                            No Items in the Cart!
                        </p>
                    )
                }
            </TableBody>
        </Table>
    </TableContainer>)
    const roomTypePricingUpdates = (<div className='RTP-Pricing-Model '>
        {roomTypePricingData.map((date_data, index) => {
            let header = (<div>
                <div className='rtp-info-heading'>
                    <Grid container direction="row" alignItems="center"
                    >
                        <Grid className='rtp-heading' item xs={1}>
                            <Grid container direction="row" alignItems="center"
                            >
                                <Grid item>{moment(date_data.stay_date).format("ddd, MMM DD, YYYY")}</Grid>
                                <Grid item>
                                    {(!date_data.success_push
                                        && !date_data.loading && !date_data.fail) &&
                                        <Button onClick={() => handleRatePush(date_data)}
                                            className='icon-btn icon-status icon-ratepush'>
                                            <span className='upload-button' style={{ marginTop: "2px" }}></span>
                                        </Button>
                                    }
                                    {(!date_data.fail && !date_data.loading && date_data.success_push === true) && (
                                        <Button className="icon-btn icon-status">
                                            <span className='in-progress'></span>
                                        </Button>
                                    )}
                                    {(!date_data.fail && !date_data.success_push && date_data.loading) && <Grid item xs={4}>

                                        <CircularProgress size={20} />

                                    </Grid>}
                                    {(!date_data.loading && !date_data.success_push && date_data.fail === true) &&
                                        (<Tooltip title={(date_data.message) ? date_data.message : ""} placement="bottom-start" arrow>
                                            <Button className='icon-btn icon-status icon-warning'>
                                                <span className='error'></span>
                                            </Button></Tooltip>)}
                                </Grid>

                                <Grid item>
                                    <Button className='icon-btn icon-status icon-cancel'
                                        onClick={() => {
                                            delete roomtype_pricing_overrides[date_data.stay_date]
                                            roomTypePricingData.splice(index, 1)
                                            if (roomTypePricingData.length === 0) {
                                                setConfirmAllBtnEnabled(false); // Button Disabled
                                                closeModalDelayed(0);
                                            }
                                            setRoomTypePricingData(roomTypePricingData)
                                            dispatch(updateAppState("change_pricing_rates", {
                                                app_state: {
                                                    roomtype_pricing_overrides: { ...roomtype_pricing_overrides }
                                                }
                                            }))
                                        }}>
                                        {/* <span className='push-delete'></span> */}
                                        <span className='delete-button' style={{ display: "flex", alignItems: "center" }}>
                                            <svg width="17" height="17" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.76531 3.76531L5.53016 5L6.76531 6.23469C6.80016 6.26953 6.82779 6.31089 6.84665 6.35641C6.86551 6.40194 6.87521 6.45073 6.87521 6.5C6.87521 6.54927 6.86551 6.59806 6.84665 6.64359C6.82779 6.68911 6.80016 6.73047 6.76531 6.76531C6.73047 6.80015 6.68911 6.82779 6.64359 6.84665C6.59807 6.8655 6.54928 6.87521 6.5 6.87521C6.45073 6.87521 6.40194 6.8655 6.35642 6.84665C6.31089 6.82779 6.26953 6.80015 6.23469 6.76531L5 5.53016L3.76531 6.76531C3.73047 6.80015 3.68911 6.82779 3.64359 6.84665C3.59807 6.8655 3.54928 6.87521 3.5 6.87521C3.45073 6.87521 3.40194 6.8655 3.35642 6.84665C3.31089 6.82779 3.26953 6.80015 3.23469 6.76531C3.19985 6.73047 3.17221 6.68911 3.15335 6.64359C3.1345 6.59806 3.12479 6.54927 3.12479 6.5C3.12479 6.45073 3.1345 6.40194 3.15335 6.35641C3.17221 6.31089 3.19985 6.26953 3.23469 6.23469L4.46985 5L3.23469 3.76531C3.16432 3.69495 3.12479 3.59951 3.12479 3.5C3.12479 3.40049 3.16432 3.30505 3.23469 3.23469C3.30505 3.16432 3.40049 3.12479 3.5 3.12479C3.59951 3.12479 3.69495 3.16432 3.76531 3.23469L5 4.46984L6.23469 3.23469C6.26953 3.19985 6.31089 3.17221 6.35642 3.15335C6.40194 3.1345 6.45073 3.12479 6.5 3.12479C6.54928 3.12479 6.59807 3.1345 6.64359 3.15335C6.68911 3.17221 6.73047 3.19985 6.76531 3.23469C6.80016 3.26953 6.82779 3.31089 6.84665 3.35641C6.86551 3.40194 6.87521 3.45073 6.87521 3.5C6.87521 3.54927 6.86551 3.59806 6.84665 3.64359C6.82779 3.68911 6.80016 3.73047 6.76531 3.76531ZM9.875 5C9.875 5.96418 9.58909 6.90671 9.05342 7.7084C8.51774 8.51009 7.75637 9.13494 6.86558 9.50391C5.97479 9.87289 4.99459 9.96943 4.04894 9.78133C3.10328 9.59323 2.23464 9.12893 1.55286 8.44715C0.871076 7.76536 0.406777 6.89672 0.218674 5.95107C0.030571 5.00541 0.127112 4.02521 0.496089 3.13442C0.865067 2.24363 1.48991 1.48226 2.2916 0.946586C3.09329 0.410914 4.03582 0.125 5 0.125C6.29251 0.126365 7.5317 0.640418 8.44564 1.55436C9.35958 2.46831 9.87364 3.70749 9.875 5ZM9.125 5C9.125 4.18415 8.88308 3.38663 8.42981 2.70827C7.97655 2.02992 7.33232 1.50121 6.57857 1.189C5.82483 0.876785 4.99543 0.795097 4.19525 0.954261C3.39508 1.11342 2.66008 1.50629 2.08319 2.08318C1.5063 2.66008 1.11343 3.39508 0.954263 4.19525C0.795099 4.99542 0.876788 5.82482 1.189 6.57857C1.50121 7.33231 2.02992 7.97655 2.70827 8.42981C3.38663 8.88307 4.18415 9.125 5 9.125C6.09364 9.12376 7.14213 8.68876 7.91545 7.91545C8.68877 7.14213 9.12376 6.09364 9.125 5Z" fill="#E03131" />
                                            </svg>

                                        </span>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </div></div>);

            let updates = [];
            date_data.date_updates.map((room_update, update_index) => {
                if (room_update.SellRate) {
                    updates.push(<Grid item className='margin-bottom'>

                        <Box>
                            <Stack direction="row" spacing={1}>
                                <Chip className='room-property'
                                    avatar={<div className='avtar-size'>{room_update.room_code}</div>}
                                    label={<div className='property-value'><span>
                                        {ui_state.currency_symbol}{room_update.previous_rate}</span>
                                        {ui_state.currency_symbol}{room_update.SellRate}
                                    </div>}

                                    onDelete={() => {
                                        delete roomtype_pricing_overrides[date_data.stay_date][room_update.room_code];
                                        roomTypePricingData[index].date_updates.splice(update_index, 1)
                                        if (roomTypePricingData[index].date_updates.length === 0) {
                                            roomTypePricingData.splice(index, 1)
                                        }
                                        if (roomTypePricingData.length === 0) {
                                            setConfirmAllBtnEnabled(false); // Button Disabled
                                        }
                                        setRoomTypePricingData(roomTypePricingData)
                                        dispatch(updateAppState("change_pricing_rates", {
                                            app_state: {
                                                roomtype_pricing_overrides: { ...roomtype_pricing_overrides }
                                            }
                                        }))
                                    }}
                                    deleteIcon={<span className='delete-button'>
                                        <svg width="14" height="14" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M6.76531 3.76531L5.53016 5L6.76531 6.23469C6.80016 6.26953 6.82779 6.31089 6.84665 6.35641C6.86551 6.40194 6.87521 6.45073 6.87521 6.5C6.87521 6.54927 6.86551 6.59806 6.84665 6.64359C6.82779 6.68911 6.80016 6.73047 6.76531 6.76531C6.73047 6.80015 6.68911 6.82779 6.64359 6.84665C6.59807 6.8655 6.54928 6.87521 6.5 6.87521C6.45073 6.87521 6.40194 6.8655 6.35642 6.84665C6.31089 6.82779 6.26953 6.80015 6.23469 6.76531L5 5.53016L3.76531 6.76531C3.73047 6.80015 3.68911 6.82779 3.64359 6.84665C3.59807 6.8655 3.54928 6.87521 3.5 6.87521C3.45073 6.87521 3.40194 6.8655 3.35642 6.84665C3.31089 6.82779 3.26953 6.80015 3.23469 6.76531C3.19985 6.73047 3.17221 6.68911 3.15335 6.64359C3.1345 6.59806 3.12479 6.54927 3.12479 6.5C3.12479 6.45073 3.1345 6.40194 3.15335 6.35641C3.17221 6.31089 3.19985 6.26953 3.23469 6.23469L4.46985 5L3.23469 3.76531C3.16432 3.69495 3.12479 3.59951 3.12479 3.5C3.12479 3.40049 3.16432 3.30505 3.23469 3.23469C3.30505 3.16432 3.40049 3.12479 3.5 3.12479C3.59951 3.12479 3.69495 3.16432 3.76531 3.23469L5 4.46984L6.23469 3.23469C6.26953 3.19985 6.31089 3.17221 6.35642 3.15335C6.40194 3.1345 6.45073 3.12479 6.5 3.12479C6.54928 3.12479 6.59807 3.1345 6.64359 3.15335C6.68911 3.17221 6.73047 3.19985 6.76531 3.23469C6.80016 3.26953 6.82779 3.31089 6.84665 3.35641C6.86551 3.40194 6.87521 3.45073 6.87521 3.5C6.87521 3.54927 6.86551 3.59806 6.84665 3.64359C6.82779 3.68911 6.80016 3.73047 6.76531 3.76531ZM9.875 5C9.875 5.96418 9.58909 6.90671 9.05342 7.7084C8.51774 8.51009 7.75637 9.13494 6.86558 9.50391C5.97479 9.87289 4.99459 9.96943 4.04894 9.78133C3.10328 9.59323 2.23464 9.12893 1.55286 8.44715C0.871076 7.76536 0.406777 6.89672 0.218674 5.95107C0.030571 5.00541 0.127112 4.02521 0.496089 3.13442C0.865067 2.24363 1.48991 1.48226 2.2916 0.946586C3.09329 0.410914 4.03582 0.125 5 0.125C6.29251 0.126365 7.5317 0.640418 8.44564 1.55436C9.35958 2.46831 9.87364 3.70749 9.875 5ZM9.125 5C9.125 4.18415 8.88308 3.38663 8.42981 2.70827C7.97655 2.02992 7.33232 1.50121 6.57857 1.189C5.82483 0.876785 4.99543 0.795097 4.19525 0.954261C3.39508 1.11342 2.66008 1.50629 2.08319 2.08318C1.5063 2.66008 1.11343 3.39508 0.954263 4.19525C0.795099 4.99542 0.876788 5.82482 1.189 6.57857C1.50121 7.33231 2.02992 7.97655 2.70827 8.42981C3.38663 8.88307 4.18415 9.125 5 9.125C6.09364 9.12376 7.14213 8.68876 7.91545 7.91545C8.68877 7.14213 9.12376 6.09364 9.125 5Z" fill="#E03131" />
                                        </svg>

                                    </span>}
                                />
                            </Stack>
                        </Box>
                    </Grid>)
                }

            })
            return (<Box sx={{ flexGrow: 1 }} key={index}>{header}<Grid container spacing={1}>{updates}</Grid></Box>);
        })}
    </div>)
    return (<>
        <Modal
            className="popup-modal-wrap"
            open={ui_state.pricingRateModalOpen === true && APP_CACHE.pricingRateModalOpen === true}
            onClose={() => {
                if (!ui_state.showspinner && !app_state.data_load) {
                    console.log("close")
                    Object.keys(app_state.pricing_override_rates).forEach(stay_date => {
                        if (app_state.pricing_override_rates[stay_date].success_push) {
                            delete app_state.pricing_override_rates[stay_date];
                        }
                    })
                    Object.keys(app_state.roomtype_pricing_overrides).forEach(stay_date => {
                        if (app_state.roomtype_pricing_overrides[stay_date].success_push) {
                            delete app_state.roomtype_pricing_overrides[stay_date];
                        }
                    });
                    if (app_state.bulkPricingSave) {
                        setOpenRateClosePopup(true);
                        return;
                    }
                    APP_CACHE.pricingRateModalOpen = false;
                    dispatch({
                        type: UPDATE_STATE, payload: {
                            app_state: {
                                bulkPricingSave: false,
                                pricing_override_rates: app_state.pricing_override_rates,
                                roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                            },
                            ui_state: { pricingRateModalOpen: false }
                        }
                    });
                }

                // dispatch(updateAppState("sendPricingRateClose", {
                //     app_state: {
                //         pricing_override_rates: app_state.pricing_override_rates,
                //         roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                //     },
                //     ui_state: { pricingRateModalOpen: false }
                // }));

            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box className='popup-modal modal-pricing'>



                <Box className='modal-titlebar'>
                    <Grid container spacing={0} className='PricingModal'>
                        <Grid item xs={7}>
                            <item><span className='text-green'>Pricing -</span> Review and update </item>
                        </Grid>
                        <Grid className='right-cta' xs={5} item alignItems="end">
                            <Badge anchorOrigin={{ vertical: 'top', horizontal: 'right', }} component="div" badgeContent={rows.numUpdates} color="primary" className='btn-ratepush' sx={{ mt: 0, mr: 1, position: 'relative' }}>
                                <Button className={'PushRateButton-popup ' + (!confirmAllBtnEnabled ? 'disabled' : '')} disabed={!confirmAllBtnEnabled} size="small" sx={{ m: "auto" }} onClick={() => handleRatePush()}>
                                    {confirmAllBtnSpinner ?
                                        <CircularProgress size={18} sx={{ color: "#acf479" }} />
                                        :
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#fff" viewBox="0 0 256 256"><path d="M178.34,165.66,160,147.31V208a8,8,0,0,1-16,0V147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32ZM160,40A88.08,88.08,0,0,0,81.29,88.68,64,64,0,1,0,72,216h40a8,8,0,0,0,0-16H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.12A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,100.8,66,8,8,0,0,0,3.2,15.34,7.9,7.9,0,0,0,3.2-.68A88,88,0,0,0,160,40Z"></path></svg>
                                    }
                                    <div>confirm all changes</div>
                                </Button>

                            </Badge>
                            <IconButton aria-label="delete" onClick={() => {
                                let name = "";
                                if (isRoomTypePricing) {
                                    name = "RoomPricingRates"
                                    generateRoomTypeExcel(name, property_name, app_state.roomtype_pricing_overrides, app_state.workspace_controls.exportType)
                                } else {
                                    name = "PricingRates"
                                    downloadReportToExcel(name, property_name, "pricingRatesTable", app_state.workspace_controls.exportType)
                                }

                            }}>
                                <FileDownloadOutlinedIcon className='Rate-Push-DownloadButton '

                                    fontSize='large' />
                            </IconButton>

                            <Button sx={{
                                minWidth: 'auto', position: 'absolute', top: -12, right: -12, width: '24px', height: '24px', p: '7px',
                                borderRadius: '50%', borderWidth: '1px', borderStyle: 'solid',
                                borderColor: '#ccc', boxShadow: '0 0 4px #000', background: '#000', color: '#FFF', fontSize: '10px',
                                '&:hover': { backgroundColor: '#000' }
                            }} style={!confirmAllBtnSpinner ? { cursor: "pointer" } : { cursor: "not-allowed" }}
                                onClick={() => {
                                    if (!confirmAllBtnSpinner) {
                                        Object.keys(app_state.pricing_override_rates).forEach(stay_date => {
                                            if (app_state.pricing_override_rates[stay_date].success_push) {
                                                delete app_state.pricing_override_rates[stay_date];
                                            }
                                        })
                                        Object.keys(app_state.roomtype_pricing_overrides).forEach(stay_date => {
                                            if (app_state.roomtype_pricing_overrides[stay_date].success_push) {
                                                delete app_state.roomtype_pricing_overrides[stay_date];
                                            }
                                            else {
                                                delete app_state.roomtype_pricing_overrides[stay_date].fail;
                                                delete app_state.roomtype_pricing_overrides[stay_date].loading;
                                            }
                                        })
                                        if (app_state.bulkPricingSave) {
                                            setOpenRateClosePopup(true);
                                            return;
                                        }
                                        dispatch({
                                            type: UPDATE_STATE, payload: {
                                                app_state: {

                                                    pricing_override_rates: app_state.pricing_override_rates,
                                                    roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                                                },
                                                ui_state: { pricingRateModalOpen: false }
                                            }
                                        });
                                        APP_CACHE.pricingRateModalOpen = false;
                                        // dispatch(updateAppState("sendPricingRateClose", {

                                        //     app_state: {
                                        //         pricing_override_rates: app_state.pricing_override_rates,
                                        //         roomtype_pricing_overrides: { ...app_state.roomtype_pricing_overrides }
                                        //     },
                                        //     ui_state: { pricingRateModalOpen: false }
                                        // }));
                                    }
                                }}>
                                <CloseSharpIcon fontSize='small' />
                            </Button>
                        </Grid>
                    </Grid>
                </Box>


                <Box sx={{ height: '100%' }} id="pricingRatesTable">

                    {/* rate listing white section */}

                    {(numUpdates > 0 && isRoomTypePricing === false) && housePricingTable}
                    {(numUpdates > 0 && isRoomTypePricing === true) && roomTypePricingUpdates}
                    {numUpdates < 1 && (
                        <p style={{ paddingLeft: '16px' }}>
                            No Items in the Cart!
                        </p>
                    )}

                    {ratePushSucessOpen && ratePushSucessDiv}
                    {openRateClosepopup && rateCloseBulk}
                    {ratePushFail && (<Stack sx={{ width: '100%' }} spacing={2}>
                        <Alert severity="warning" sx={{ color: "#C02E2E" }}>Something Went Wrong, Please Try Again</Alert>
                    </Stack>)}
                </Box>
            </Box>
        </Modal>
    </>);
}